import React, { Component } from "react";

class ContactTwo extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnMessage: '',
        };
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
    
        const { rnName, rnEmail, rnSubject, rnMessage } = this.state;
    
        // Simple validation
        if (!rnName || !rnEmail || !rnSubject || !rnMessage) {
            alert("Please fill in all fields.");
            return;
        }
    
        // TODO: Connect to API or email service
        console.log("Form submitted with:", {
            name: rnName,
            email: rnEmail,
            subject: rnSubject,
            message: rnMessage,
        });
    
        // Reset form fields
        this.setState({
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnMessage: '',
        });
    
        alert("Thank you! Your message has been sent.");
    };

    render(){
        return(
            <div className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-5 order-1 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <h2 className="title">Contact Me.</h2>
                                <p className="description">Interested in booking me for a keynote or exploring collaboration opportunities? Let's connect! Please fill out the form below to discuss potential coaching, consulting, or media engagements.</p>
                                
                                <p className="description">Kindly note, while I truly appreciate anyone inviting me to address their organisation or events, unfortunately, I am unable to speak for free or for exposure/book sales. Thank you for understanding, and I look forward to the possibility of working together.</p>
                            </div>
                        </div>

                        <div className="col-lg-6 order-2 order-lg-2 float-end">
                            <h5 className="title">Let's connect.</h5>
                            <div className="form-wrapper">
                                <form onSubmit={this.handleFormSubmit}>
                                    <label htmlFor="item01">
                                        <input
                                            type="text"
                                            name="name"
                                            id="item01"
                                            value={this.state.rnName}
                                            onChange={(e)=>{this.setState({rnName: e.target.value});}}
                                            placeholder="Your Name *"
                                        />
                                    </label>

                                    <label htmlFor="item02">
                                        <input
                                            type="text"
                                            name="email"
                                            id="item02"
                                            value={this.state.rnEmail}
                                            onChange={(e)=>{this.setState({rnEmail: e.target.value});}}
                                            placeholder="Your email *"
                                        />
                                    </label>

                                    <label htmlFor="item03">
                                        <input
                                            type="text"
                                            name="subject"
                                            id="item03"
                                            value={this.state.rnSubject}
                                            onChange={(e)=>{this.setState({rnSubject: e.target.value});}}
                                            placeholder="Write a Subject"
                                        />
                                    </label>
                                    <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label>
                                    <button className="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Submit</button>
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src="/assets/images/about/about-6.jpg" alt="trydo"/>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactTwo;